module.exports = __webpack_public_path__ + "img/HardenedPowerArmor.e1ad6400.gif";